import { ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import RootRouter from './router';
import zhCN from 'antd/locale/zh_CN';
import { themeConfig, PREFIX_CLS } from './theme';
import 'antd/dist/reset.css';
import '@ant-design/v5-patch-for-react-19';

// 创建数据 Query 客户端
const client = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false } },
});

const App = () => {
  return (
    <ConfigProvider
      locale={zhCN}
      autoInsertSpaceInButton={false}
      prefixCls={PREFIX_CLS}
      theme={themeConfig}>
      <QueryClientProvider client={client}>
        {process.env.NODE_ENV === 'development' ? <ReactQueryDevtools /> : null}
        <RootRouter />
      </QueryClientProvider>
    </ConfigProvider>
  );
};

export default App;
